export default __webpack_public_path__ + "static/media/hello-ermine_logo.f19b459d.png";